import {
  PosVendaConfirmacaoEnderecoFilaQuery,
  PosVendaFluxoLogisticoFilaQuery,
  PosVendaProtocoloStatus,
  PosVendaProtocolosFiltros,
} from '../../types/posVenda';

export const POS_VENDA_STALE_MS = 30_000;

export const posVendaQueryKeys = {
  all: () => ['posVenda'] as const,
  me: () => [...posVendaQueryKeys.all(), 'me'] as const,
  protocolos: (filtros: PosVendaProtocolosFiltros) =>
    [...posVendaQueryKeys.all(), 'protocolos', filtros] as const,
  protocolosContagens: (filtros: PosVendaProtocolosFiltros) =>
    [...posVendaQueryKeys.all(), 'protocolos', 'contagens', filtros] as const,
  protocolosKanbanColumn: (filtros: PosVendaProtocolosFiltros, status: PosVendaProtocoloStatus) =>
    [...posVendaQueryKeys.all(), 'protocolos', 'kanban', status, filtros] as const,
  protocolo: (id: string) => [...posVendaQueryKeys.all(), 'protocolo', id] as const,
  kpis: (filtros: PosVendaProtocolosFiltros) => [...posVendaQueryKeys.all(), 'kpis', filtros] as const,
  clientePainel: (clientId: string) => [...posVendaQueryKeys.all(), 'clientePainel', clientId] as const,
  membros: () => [...posVendaQueryKeys.all(), 'membros'] as const,
  filtrosOpcoes: () => [...posVendaQueryKeys.all(), 'filtrosOpcoes'] as const,
  config: () => [...posVendaQueryKeys.all(), 'config'] as const,
  confirmacaoEnderecoFila: (query: PosVendaConfirmacaoEnderecoFilaQuery = {}, session = '') =>
    [...posVendaQueryKeys.all(), 'confirmacaoEndereco', session, 'fila', query] as const,
  confirmacaoEnderecoMetricas: (session = '') =>
    [...posVendaQueryKeys.all(), 'confirmacaoEndereco', session, 'metricas'] as const,
  confirmacaoEnderecoContrato: (contractId: string, session = '') =>
    [...posVendaQueryKeys.all(), 'confirmacaoEndereco', session, 'contrato', contractId] as const,
  fluxoLogisticoFila: (query: PosVendaFluxoLogisticoFilaQuery = {}, session = '') =>
    [...posVendaQueryKeys.all(), 'fluxoLogistico', session, 'fila', query] as const,
  fluxoLogisticoMetricas: (session = '') => [...posVendaQueryKeys.all(), 'fluxoLogistico', session, 'metricas'] as const,
  fluxoLogisticoContrato: (contractId: string, session = '') =>
    [...posVendaQueryKeys.all(), 'fluxoLogistico', session, 'contrato', contractId] as const,
};
